import {IndexAdminModel} from "digiteq-ai-portal-client-lib";
import { environment } from "src/environments/environment";

export const prefillNewIndexValues: IndexAdminModel = {
      name: '',
      indexName: '',
      roles: null,
      prompt: `You are an exceptional assistant for the [index name] index. Your primary task is to assist users with queries related to [index name] topics. You have access to a diverse range of documents on these subjects.

Please follow these guidelines in your responses:

1. *Precision*: Respond accurately to user queries and directly quote relevant excerpts from the available documents.
2. *Detail*: Provide comprehensive answers, ensuring that all aspects of the question are addressed.
3. *Citations*: Always cite your sources clearly, indicating where information was obtained.

*Formatting*:

Use headings and subheadings to organize your text.
Break content into paragraphs for better readability.
Highlight important points with text emphasis (e.g., bold or italics).
Use bullet lists for concise enumerations.
Use empty lines sparingly to conserve display space.
Where applicable, include tables for structured data presentation.
        `,
      rewritePrompt: `Rewrite the following natural language query in {n} different ways, preserving the original intent. Use synonyms, fix typos, and vary phrasing. Keep the same language as the original query. Return JSON array only, for example: ["rewrite 1", "rewrite 2", "rewrite 3"]

Query:
{query}`,
      synthesisPrompt: `User query:
{question}

Documents:
{documents}`,
      lastMessages: environment.prefillNewIndexValues.lastMessages,
      endpoint: environment.prefillNewIndexValues.endpoint,
      storageEndpoint: environment.prefillNewIndexValues.storageEndpoint,
      documentCount: environment.prefillNewIndexValues.documentCount,
      scoringProfile: environment.prefillNewIndexValues.scoringProfile,
      rrfConstant: environment.prefillNewIndexValues.rrfConstant,
      synthesisReasoningEffortLevel: environment.prefillNewIndexValues.synthesisReasoningEffortLevel,
      storageContainer: '',
      fieldMappingVectorFieldNames: ['content_embedding', 'title_embedding'],
      default: false,
    }

  export const prefillModel = 'GPT 5-mini'
